/* Nuvō video gallery (sections/nuvo-video-gallery.liquid). */

(function () {
  var root = document.querySelector('.nvg');
  if (!root) return;
  var modal = root.querySelector('.nvg__modal');
  var stage = root.querySelector('.nvg__stage');
  var lastFocus = null;

  function open(id) {
    var tpl = document.getElementById(id);
    if (!tpl) return;
    lastFocus = document.activeElement;
    stage.innerHTML = '';
    stage.appendChild(tpl.content.cloneNode(true));
    document.documentElement.style.overflow = 'hidden';
    if (typeof modal.showModal === 'function') { modal.showModal(); } else { modal.setAttribute('open', ''); }
    var v = stage.querySelector('video');
    if (v) { var p = v.play(); if (p && p.catch) { p.catch(function () {}); } }
  }
  function close() { if (modal.open) { modal.close(); } else { cleanup(); } }
  function cleanup() {
    stage.innerHTML = '';
    document.documentElement.style.overflow = '';
    if (lastFocus && lastFocus.focus) { lastFocus.focus(); }
  }
  root.querySelectorAll('[data-nvg-open]').forEach(function (btn) {
    btn.addEventListener('click', function () { open(btn.getAttribute('data-nvg-open')); });
  });
  root.querySelector('.nvg__close').addEventListener('click', close);
  modal.addEventListener('click', function (e) { if (e.target === modal) close(); });
  modal.addEventListener('close', cleanup);

  if (root.getAttribute('data-guide')) {
  /* Link under the Ignition dropdown. The variant picker can be re-rendered when an
     option changes, so the link is re-added whenever it goes missing. */
  var guideId = root.getAttribute('data-guide');
  var guideTime = root.getAttribute('data-guide-time') || '';
  function addGuideLink() {
    var sel = document.querySelector('select[name="options[Ignition]"], input[name="options[Ignition]"]');
    if (!sel) return;
    var box = sel.closest('.product-form__input') || sel.parentNode;
    if (!box || box.querySelector('.nvg-guide-link')) return;
    var b = document.createElement('button');
    b.type = 'button';
    b.className = 'nvg-guide-link';
    b.innerHTML = '<span class="nvg-guide-link__icon"><svg viewBox="0 0 24 24" width="9" height="9" aria-hidden="true"><path fill="currentColor" d="M7 4.5v15l12.5-7.5z"/></svg></span><span class="nvg-guide-link__text">Not sure which ignition? Watch the guide' + (guideTime ? ' (' + guideTime + ')' : '') + '</span>';
    b.addEventListener('click', function () { open(guideId); });
    box.appendChild(b);
  }
  addGuideLink();
  var form = document.querySelector('select[name="options[Ignition]"], input[name="options[Ignition]"]');
  var watchRoot = form ? (form.closest('product-info, .product__info-container, form, section') || document.body) : null;
  if (watchRoot && 'MutationObserver' in window) {
    var t;
    new MutationObserver(function () { clearTimeout(t); t = setTimeout(addGuideLink, 60); }).observe(watchRoot, { childList: true, subtree: true });
  }
  }

  /* Entrance: featured card first, the others after, as the section scrolls into view */
  var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  if (reduce || !Element.prototype.animate || !('IntersectionObserver' in window) || window.Shopify && Shopify.designMode) return;
  var cards = Array.prototype.slice.call(root.querySelectorAll('.nvg__card'));
  if (!cards.length) return;
  var rect = root.getBoundingClientRect();
  if (rect.top < window.innerHeight * 0.85 && rect.bottom > 0) return;
  /* Cards are hidden only while the section is below the fold, so nothing visible ever blinks. */
  root.classList.add('is-pending');
  function reveal() { root.classList.remove('is-pending'); }

  var io = new IntersectionObserver(function (entries) {
    if (!entries.some(function (e) { return e.isIntersecting; })) return;
    io.disconnect();
    play();
  }, { threshold: 0.18 });
  io.observe(root.querySelector('.nvg__cards'));

  function play() {
    var vw = window.innerWidth;
    var compact = vw <= 749;
    var rise = compact ? 12 : 18;
    var place = 'cubic-bezier(.16,1,.3,1)';
    var wipe = 'cubic-bezier(.24,.86,.28,1)';
    var boxes = cards.map(function (c) { return c.getBoundingClientRect(); });
    var top = Math.min.apply(null, boxes.map(function (b) { return b.top; }));
    var oneRow = boxes.every(function (b) { return Math.abs(b.top - top) <= Math.max(4, b.height * 0.04); });
    var mid = vw / 2;
    var order = cards.map(function (c, i) { return i; }).sort(function (a, b) {
      var fa = cards[a].classList.contains('is-featured') ? 0 : 1;
      var fb = cards[b].classList.contains('is-featured') ? 0 : 1;
      if (oneRow) {
        if (fa !== fb) return fa - fb;
        return Math.abs(boxes[a].left + boxes[a].width / 2 - mid) - Math.abs(boxes[b].left + boxes[b].width / 2 - mid);
      }
      return (boxes[a].top - boxes[b].top) || (boxes[a].left - boxes[b].left);
    });
    var anims = [];
    try {
      order.forEach(function (idx, n) {
        var card = cards[idx];
        var b = boxes[idx];
        var lead = card.classList.contains('is-featured');
        var delay = oneRow ? (lead ? 60 : 245 + (n - 1) * 85) : 70 + n * 115;
        var drift = 0;
        if (oneRow && !lead) { var off = b.left + b.width / 2 - mid; drift = -Math.sign(off) * Math.min(b.width * 0.018, 7); }
        var opt = function (d, dur, ease) { return { delay: d, duration: dur, easing: ease, fill: 'both' }; };
        anims.push(card.animate([{ opacity: 0, transform: 'translate3d(' + drift + 'px,' + rise + 'px,0) scale(.985)' }, { opacity: 1, transform: 'none' }], opt(delay, compact ? 780 : (lead ? 960 : 900), place)));
        var panel = card.querySelector('.nvg__panel');
        if (panel) anims.push(panel.animate([{ opacity: 0, transform: 'scale(.994)', clipPath: 'inset(0 0 ' + (compact ? 26 : 34) + '% 0 round 12px)' }, { opacity: 1, transform: 'none', clipPath: 'inset(0 0 0 0 round 12px)' }], opt(delay + 200, compact ? 620 : 720, wipe)));
        var copy = card.querySelector('.nvg__copy');
        if (copy) anims.push(copy.animate([{ opacity: 0, transform: 'translate3d(0,' + (compact ? 8 : 11) + 'px,0)' }, { opacity: 1, transform: 'none' }], opt(delay + 330, compact ? 540 : 620, place)));
        var title = card.querySelector('.nvg__title');
        if (title) anims.push(title.animate([{ opacity: 0, clipPath: 'inset(-30% 0 100% 0)' }, { opacity: 1, clipPath: 'inset(-30% 0 -30% 0)' }], opt(delay + 350, compact ? 470 : 540, wipe)));
        var desc = card.querySelector('.nvg__desc');
        if (desc) anims.push(desc.animate([{ opacity: 0, clipPath: 'inset(-30% 0 100% 0)' }, { opacity: 1, clipPath: 'inset(-30% 0 -30% 0)' }], opt(delay + 450, compact ? 430 : 490, wipe)));
        var icon = card.querySelector('.nvg__icon');
        if (icon) anims.push(icon.animate([{ opacity: 0, transform: 'scale(.88)' }, { opacity: 1, transform: 'none' }], opt(delay + 540, compact ? 340 : 400, place)));
      });
      root.classList.remove('is-pending');
      Promise.all(anims.map(function (a) { return a.finished; })).then(done, done);
    } catch (e) { done(); }
    function done() { anims.forEach(function (a) { try { a.cancel(); } catch (e) {} }); reveal(); }
  }
})();
